var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1.875C10.4766 1.875 11.875 3.27344 11.875 5V7.5H5.625V5C5.625 3.27344 7.02344 1.875 8.75 1.875ZM3.75 5V7.5H2.5C1.12109 7.5 0 8.62109 0 10V17.5C0 18.8789 1.12109 20 2.5 20H15C16.3789 20 17.5 18.8789 17.5 17.5V10C17.5 8.62109 16.3789 7.5 15 7.5H13.75V5C13.75 2.23828 11.5117 0 8.75 0C5.98828 0 3.75 2.23828 3.75 5ZM2.5 9.375H15C15.3438 9.375 15.625 9.65625 15.625 10V17.5C15.625 17.8438 15.3438 18.125 15 18.125H2.5C2.15625 18.125 1.875 17.8438 1.875 17.5V10C1.875 9.65625 2.15625 9.375 2.5 9.375ZM9.6875 12.5C9.6875 11.9805 9.26953 11.5625 8.75 11.5625C8.23047 11.5625 7.8125 11.9805 7.8125 12.5V15C7.8125 15.5195 8.23047 15.9375 8.75 15.9375C9.26953 15.9375 9.6875 15.5195 9.6875 15V12.5Z",
    fill: "#485E75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d984242020a5de7ee09f2a6d0595fd8c.svg";
export { ForwardRef as ReactComponent };